import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.core').config(routesConfig);

  routesConfig.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];

  /* @ngInject */
  function routesConfig($locationProvider, $stateProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(false).hashPrefix(''); // Séparateur # plutôt que #! par défaut

    // It's for http://url:8080/kiss-boclient/
    $urlRouterProvider.when('', '/');

    $urlRouterProvider.otherwise('/');

    $stateProvider.state('app', {
      abstract: true,
      template: '<ui-view/>',
      data: {
        authorizedRole: 'USER_BO'
      }
    });
  }
})();
